import {useMutation} from 'src/graphql';
import {ADD_SURVEY_RESPONSE} from 'src/graphql/survey/mutation'
import { useCallback } from 'react';

export default () =>{
  const [addSurveyResponse] = useMutation(ADD_SURVEY_RESPONSE);

  return useCallback(params=>addSurveyResponse({variables:params}),[])
}
